<template>
  <div id="app">
    <nav class="navbar navbar-default navbar-fixed-top">
      <div class="container">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle" aria-expanded="false" aria-controls="navbar"
                  v-on:click="toggleMobileMenu">
            <a :class="'menu-mobile '+  (mobileMenuVisible?'menu-mobile-opened ':'')"></a>
          </button>
          <router-link to="/" class="navbar-brand"><img src="/img/logo.png"></router-link>
        </div>
        <div id="navbar" :class="'navbar-collapse collapse ' + (mobileMenuVisible?'in':'')">
          <ul class="nav navbar-nav">
            <li><a href="https://docs.predicthq.com/tools/tableau-connector" target="_blank">Technical documentation</a></li>
            <li><a href="https://www.predicthq.com" target="_blank">Website</a></li>
          </ul>
        </div><!--/.nav-collapse -->
      </div>
    </nav>

    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'app',
    data () {
      return {
        mobileMenuVisible: false
      }
    },
    methods: {
      toggleMobileMenu () {
        this.mobileMenuVisible = !this.mobileMenuVisible
      }
    }
  }
</script>

<style lang="scss">
  @import "assets/styles/app";
</style>
